import { useState, useEffect } from "react";
import "./header.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link, useNavigate, useLocation } from "react-router-dom";

export default function Header() {
    const [open, setOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Check if user is logged in
        const checkAuth = () => {
            const token = localStorage.getItem("token");
            setIsLoggedIn(!!token);
        };

        checkAuth();

        // Listen for storage changes (when login/logout happens in other tabs/components)
        window.addEventListener("storage", checkAuth);

        // Also listen for custom event for same-tab updates
        window.addEventListener("authChange", checkAuth);

        return () => {
            window.removeEventListener("storage", checkAuth);
            window.removeEventListener("authChange", checkAuth);
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setIsLoggedIn(false);
        // Dispatch custom event to update header in same tab
        window.dispatchEvent(new Event("authChange"));
        navigate("/login");
    };

    const scrollToSection = (sectionId) => {
        // Close mobile menu if open
        setOpen(false);

        // If not on homepage, navigate there first with hash
        if (location.pathname !== "/") {
            navigate(`/#${sectionId}`);
            // Wait for navigation and page load, then scroll
            setTimeout(() => {
                const element = document.getElementById(sectionId);
                if (element) {
                    const headerHeight = 80; // Approximate header height
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                }
            }, 300);
        } else {
            // Already on homepage, just scroll
            const element = document.getElementById(sectionId);
            if (element) {
                const headerHeight = 80; // Approximate header height
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    };

    // Check if a link is active
    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <header className="header">
            <div className="header-strip">
                Operated by{" "}
                <a href="https://www.rxconnect.ca/" target="_blank" rel="noopener noreferrer">
                    Rx Connect Specialty Pharmacy
                </a>
            </div>
            <div className="container">
                {/* Logo */}
                <Link to="/" className="logo" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: "10px" }} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    <i class="fa-solid fa-scale-balanced"></i>               
                    <div>
                        <h1>Sandy Randhawa</h1>
                        <p>Family Law Solicitor</p>
                    </div>
                </Link>

                {/* Desktop Navigation */}
                <nav className="nav">
                    <Link to="/about" className={isActive("/about") ? "active" : ""}>About</Link>
                    <Link to="/services" className={isActive("/services") ? "active" : ""}>Services</Link>
                    <Link to="/how-we-work" className={isActive("/how-we-work") ? "active" : ""}>How We Work</Link>
                    <Link to="/testimonials" className={isActive("/testimonials") ? "active" : ""}>Testimonials</Link>
                    <Link to="/resources" className={isActive("/resources") ? "active" : ""}>Resources</Link>
                    <Link to="/contact" className={isActive("/contact") ? "active" : ""}>Contact</Link>
                </nav>

                {/* Right Actions */}
                <div className="actions">
                    <div className="phone">
                        <i className="fa-solid fa-phone"></i>
                        <span>01900 123456</span>
                    </div>
                    {isLoggedIn ? (
                        <>
                            <Link to="/my-profile" className="btn">My Profile</Link>
                            <button onClick={handleLogout} className="btn logout-btn">Logout</button>
                        </>
                    ) : (
                        <Link to="/login" className="btn">Login Now</Link>
                    )}
                </div>

                {/* Mobile Menu Button */}
                <button className="menu-btn" onClick={() => setOpen(!open)}>
                    {open ? (
                        <i className="fa-solid fa-xmark"></i>
                    ) : (
                        <i className="fa-solid fa-bars"></i>
                    )}
                </button>
            </div>

            {/* Mobile Menu */}
            {open && (
                <div className="mobile-menu">
                    <Link to="/about" className={isActive("/about") ? "active" : ""} onClick={() => setOpen(false)}>About</Link>
                    <Link to="/services" className={isActive("/services") ? "active" : ""} onClick={() => setOpen(false)}>Services</Link>
                    <Link to="/how-we-work" className={isActive("/how-we-work") ? "active" : ""} onClick={() => setOpen(false)}>How We Work</Link>
                    <Link to="/testimonials" className={isActive("/testimonials") ? "active" : ""} onClick={() => setOpen(false)}>Testimonials</Link>
                    <Link to="/resources" className={isActive("/resources") ? "active" : ""} onClick={() => setOpen(false)}>Resources</Link>
                    <Link to="/contact" className={isActive("/contact") ? "active" : ""} onClick={() => setOpen(false)}>Contact</Link>

                    <div className="mobile-actions">
                        <div className="phone">
                            <i className="fa-solid fa-phone"></i>
                            <span>01900 123456</span>
                        </div>
                        {isLoggedIn ? (
                            <>
                                <Link to="/my-profile" className="btn full">My Profile</Link>
                                <button onClick={handleLogout} className="btn full logout-btn">Logout</button>
                            </>
                        ) : (
                            <Link to="/login" className="btn full">Login Now</Link>
                        )}
                    </div>
                </div>
            )}
        </header>
    );
}
